import { forwardRef, useState } from 'react';
import cn from 'classnames';
import TextControl from '@ebsco-ui/text-control';
import Button from '@ebsco-ui/button';
import { createBemBlockBuilder } from '@ebsco-ui/utils';
import { jsx } from 'react/jsx-runtime';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var _excluded = ["id", "className", "label", "error", "disabled", "hidePasswordButtonText", "showPasswordButtonText", "descriptionId"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var baseClassName = "eb-password-input";
var PasswordInput = forwardRef(function (_ref, ref) {
  var id = _ref.id,
      className = _ref.className,
      label = _ref.label,
      error = _ref.error,
      disabled = _ref.disabled,
      hidePasswordButtonText = _ref.hidePasswordButtonText,
      showPasswordButtonText = _ref.showPasswordButtonText,
      descriptionId = _ref.descriptionId,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      isHidden = _useState2[0],
      setIsHidden = _useState2[1];

  var toggleHidden = function toggleHidden() {
    return setIsHidden(!isHidden);
  };

  var getBlocksWith = createBemBlockBuilder([className, baseClassName]);
  var buttonMessage = isHidden ? showPasswordButtonText : hidePasswordButtonText;
  return /*#__PURE__*/jsx(TextControl, {
    className: getBlocksWith(),
    label: label,
    error: error,
    labelButton: /*#__PURE__*/jsx(Button, {
      onClick: toggleHidden,
      styleType: "link",
      className: getBlocksWith("__button"),
      children: buttonMessage
    }),
    children: /*#__PURE__*/jsx("input", _objectSpread({
      type: isHidden ? "password" : "text",
      id: id,
      disabled: disabled,
      className: getBlocksWith("__input"),
      "aria-invalid": Boolean(error),
      "aria-describedby": cn(error && "".concat(id, "-error"), descriptionId),
      ref: ref
    }, rest))
  });
});
PasswordInput.displayName = "PasswordInput";

export { PasswordInput as default };
//# sourceMappingURL=password-input-esm.js.map
